import React from "react"
import { DateTime } from "luxon"
import { useFormikContext } from "formik"
import ReservationSidebar from "@/components/public/venue/reservation_sidebar"
import type { ReservationFormValues, VenueType } from "./types"

const FALLBACK_RESERVATION_DURATION_SECONDS = 15 * 60

const STYLES = {
  stickyWrapper: "sticky top-8",
} as const

type Props = {
  venue: VenueType
  onOpenBooking: () => void
}

const VenueDetailsColumn: React.FC<Props> = ({ venue, onOpenBooking }) => {
  const { values, setFieldValue } = useFormikContext<ReservationFormValues>()

  const handleReserveClick = async () => {
    if (values.startTime && !values.endTime) {
      const duration = Math.max(
        venue.reservationConfiguration?.minReservationTime || 0,
        FALLBACK_RESERVATION_DURATION_SECONDS,
      )
      const startTime = DateTime.fromISO(values.startTime, { setZone: true })
      await setFieldValue("endTime", startTime.plus({ seconds: duration }).toISO(), false)
    }
    onOpenBooking()
  }

  return (
    <div className={STYLES.stickyWrapper}>
      <ReservationSidebar
        onReserveClick={handleReserveClick}
        cancellationDeadline={venue.reservationConfiguration?.cancellationDeadline}
        venueSlug={venue.slug}
        timezone={venue.timezone}
        country={venue.country}
        openingHours={venue.openingHours || []}
        minAdvanceBookingTime={venue.reservationConfiguration?.minAdvanceBookingTime}
        minReservationTime={venue.reservationConfiguration?.minReservationTime}
        tables={venue.tables}
      />
    </div>
  )
}

export default VenueDetailsColumn
